<template>

  <!-- Page Subscription -->
  <div
    class="page-subscription">

    <transition
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut">

      <div
        v-if="done">

        <div
          class="column items-center text-center">

          <q-icon
            size="70px"
            color="white"
            name="fa lni-check-mark-circle"/>

          <div
            class="text-h4 q-mb-none">

            Поздравляем!

            <div
              class="q-mt-xs">
              Вы успешно подписаны.
            </div>

          </div>

        </div>

      </div>

      <div
        v-else>

        <div
          class="page-subscription__title">
          Подпишитесь на новостную рассылку
        </div>

        <q-form
          @submit="submit(email)"
          class="page-subscription__field">

          <q-input
            dark
            rounded
            standout
            lazy-rules
            v-model="email"
            :rules="emailRules"
            placeholder="введите e-mail"
            class="page-subscription__input"/>

          <q-btn
            rounded
            unelevated
            type="submit"
            :loading="loading"
            text-color="white"
            class="page-subscription__submit">
            подписаться
          </q-btn>

        </q-form>

      </div>

    </transition>

  </div>

</template>

<script>

  import {mapActions, mapState} from 'vuex';

  export default {
    name: 'page-subscription',
    props: {},
    data() {
      return {
        email: '',
        done: false,
      };
    },
    computed: {
      ...mapState('vlSubscriptions', {
        loading: 'loading',
      }),
      emailRules() {

        return [
          v => !!v || 'Введите e-mail',
          v => this.$validator.isEmail(v) || 'Неверный формат',
        ];
      },
    },
    methods: {
      ...mapActions('vlSubscriptions', {
        send: 'SUBMIT',
      }),
      submit() {

        this.done = this.$store.dispatch(
          'vlSubscriptions/SUBMIT',
          this.email,
        );
      },
    },
  };

</script>

<style lang="scss">

  .page-subscription {
    color: inherit;
    display: block;
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;

    &__title {
      font-weight: 500;
      font-size: 1.23rem;
      text-align: center;
      margin-bottom: $spacer-mm;

      @media (max-width: $breakpoint-xs) {
        font-size: 1.1rem;
      }
    }

    &__field {
      position: relative;
    }

    &__input {

      &.q-field--error .q-field__bottom {
        font-size: 1rem;
        font-weight: 500;
        padding-top: 1rem;

        @media (max-width: $breakpoint-xs) {
          padding-top: 0.65rem;
        }
      }

      .q-field__marginal {
        height: 49px;
      }

      .q-field__control {
        height: 49px;
        padding: 0 260px 0 2rem;
        background: white !important;

        @media (max-width: $breakpoint-xs) {
          padding: 0 2rem;
        }
      }

      input {
        line-height: 29px;
        color: $font-color !important;
      }
    }

    &__submit {
      top: 0;
      right: 0;
      padding: 0 $ibs-x;
      font-size: 1.2rem;
      position: absolute;
      font-weight: normal;
      text-transform: lowercase;
      background: $brand-gradient;

      @media (max-width: $breakpoint-xs) {
        width: 100%;
        position: relative;
        margin-top: $spacer-sm;
      }
    }
  }

</style>
